<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="id && !readonly" sliding>{{ $t('common.editar') }}</f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>{{ config.title }}</f7-nav-title>
      <f7-nav-title v-else sliding>{{ $t('common.nueva') }}</f7-nav-title>
      <f7-nav-right>
        <f7-button
          v-if="!readonly"
          fill
          icon-f7="floppy_disk"
          :text="$t('common.guardar')"
          class="display-flex"
          @click="$refs.rform.saveItem()"
        ></f7-button>
        <template slot="right" v-else>
          <f7-button color="blue" @click="readonly = false">{{ $t('common.editar') }}</f7-button>
          <f7-button color="red" @click="deleteItem">{{ $t('common.eliminar') }}</f7-button>
        </template>
      </f7-nav-right>
    </f7-navbar>
    <r-form
      ref="rform"
      :itemId="id"
      :readonly="readonly"
      :dbAdapter="config.dbAdapter"
      :default-data="defaultData"
      @save="onSave"
    >
      <template v-slot="{ rform }">
        <f7-card class="padding-vertical-half padding-right">
          <f7-card-content>
            <f7-row no-gap class="list list-form no-hairlines">
              <f7-col width="100" medium="50">
                <ul>
                  <r-input floating-label outline label="Orden" :form="rform" type="number" name="order"></r-input>
                  <r-input floating-label outline label="Activa" :form="rform" type="check" name="activa"></r-input>
                  <r-input floating-label outline label="Username" :form="rform" type="text" name="username" :readonly="true" :overrideReadonly="true"></r-input>
                  <template v-if="config.type === 'example'">
                    <r-input floating-label outline label="Question" :form="rform" type="textarea" name="question" :resizable="true"></r-input>
                    <r-input floating-label outline label="Approach" :form="rform" type="textarea" name="approachText" :resizable="true"></r-input>
                  </template>
                  <template v-else>
                    <r-input floating-label outline label="Text" :form="rform" type="textarea" name="text" :resizable="true"></r-input>
                  </template>
                </ul>
              </f7-col>
            </f7-row>
          </f7-card-content>
        </f7-card>
      </template>
    </r-form>
  </f7-page>
</template>

<script>
import rForm from '../../components/rForm.vue';
import rInput from '../../components/rInput.vue';
import { getAiContextConfig } from './config.js';

export default {
  components: {
    rForm,
    rInput
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    },
    contextType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      readonly: !this.editable
    };
  },
  computed: {
    config() {
      return getAiContextConfig(this.contextType);
    },
    defaultData() {
      return this.config.type === 'example'
        ? { activa: true, order: 0, approachText: '' }
        : { activa: true, order: 0, text: '' };
    }
  },
  methods: {
    deleteItem() {
      const self = this;
      self.$f7.dialog.confirm(
        self.$t('rlist.pregunta_eliminar_registro'),
        'Eliminar',
        function () {
          self.config.dbAdapter.delete({ itemId: self.id }).then(function () {
            self.$f7.toast
              .create({
                icon: '<i class="f7-icons">checkmark</i>',
                text: self.$t('rlist.registro_eliminado'),
                position: 'center',
                destroyOnClose: true,
                closeTimeout: 2000
              })
              .open();
            self.$f7router.back();
          }).catch(function (error) {
            self.$f7.dialog.alert(error.message);
          });
        }
      );
    },
    onSave() {
      const self = this;
      self.readonly = true;
      self.$f7.toast
        .create({
          text: `${self.config.title} guardado correctamente`,
          position: 'center',
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    }
  }
};
</script>
